<template>
  <div class="row">
    <div class="service">
      <div class="col-12">
        <div :style="'background:' + service.background_icon">
          <img
            :src="base_url + service.image"
            class="img_center">
        </div>
        <div class="service_name">{{ service.name }}</div>
      </div>
      <br>
      <div
        v-if="inputs && inputs.length > 0"
        class="col-12 mt-2">
        <div class="fr_form">
          <form v-if="is_laso === 0">
            <div
              v-for="att in inputs"
              class="form-group">
              <label>{{ att.display }}</label>
              <input
                v-model="att.code"
                type="hidden">
              <input
                v-if="att.type === 'text'"
                :placeholder="att.display"
                v-model="att.value"
                type="text"
                class="form-control">
              <input
                v-if="att.type === 'date' || att.type === 'month'"
                :placeholder="att.display"
                v-model="att.value"
                type="date"
                class="form-control">
              <div v-if="att.sub_items && att.sub_items.length > 0">
                <select
                  v-if="att.type === 'select'"
                  v-model="att.value"
                  class="form-control">
                  <option
                    v-for="option in att.sub_items"
                    :value="option.id">
                    {{ option.value }}
                  </option>
                </select>
              </div>
              <vue-clock-picker
                v-if="att.type === 'time'"
                v-model="att.value"
                class="form-control"
                active-color="#4CAF50"
                style="width: 100%!important;"
                input-class="clock-picker__input"
                done-text="Chọn"
                cancel-text="Hủy"/>

            </div>
            <div v-if="service.cost === 0">
              <button
                type="button"
                class="btn btn-order bg-green"
                @click="getResult()">Xem ngay
              </button>
            </div>
            <div v-if="service.cost !== 0">
              <span class="flash_sale">{{ flash_sale }}</span>
              <button
                v-if="is_laso === 0"
                type="button"
                class="btn btn-order bg-green"
                @click="getResult()">Mua dịch vụ
              </button>
            </div>
          </form>
          <button
            v-if="is_laso !== 0"
            type="button"
            class="btn btn-order bg-green"
            @click="listLaso()">Danh sách lá số
          </button>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
  import rf from '../../communicate/RequestFactory'
  import ApiConfig from '../../communicate/ApiConfig'
  import {errorToaster} from '../../services/ErrorHandler'
  import ServiceResult from './ServiceResult'
  import VueTimepicker from 'vue2-timepicker'
  import OrderType from '../../communicate/OrderType'
  import {getDob} from '../../services/authService'

  export default {
    name: 'ServiceDetail',
    components: {ServiceResult, VueTimepicker},
    data () {
      return {
        id: this.$route.params.id,
        base_url: ApiConfig.base_url,
        summary: true,
        phone: '',
        is_show: false,
        service: {},
        items: [],
        order: {
          product_code: '',
          attrs: [],
          target: -1
        },
        inputs: [],
        result: {},
        image: '',
        service_name: '',
        description: '',
        sliding: true,
        cost: 0,
        buy_success: 0,
        is_laso: 0,
        flash_sale: ''
      }
    },

    mounted () {
      this.loadDetailService(this.id)
      const userInfoStorage = localStorage.getItem('current_user')
      if (userInfoStorage) {
        const userInfo = JSON.parse(userInfoStorage)
        this.phone = userInfo.phone
      }
    },

    methods: {
      convertDate () {
        try {
          let dob = getDob()
          if (!dob) return ''
          let d = dob.split('/')
          return `${d[2]}-${d[1]}-${d[0]}`
        } catch (e) {
          return ''
        }
      },

      loadDetailService (service_id) {
        rf.getRequest('ServiceRequest').getDetailService(service_id).then((res) => {
          if (res.status === 200) {
            this.service = res.data
            this.service_name = this.service.name
            const service = {
              'id': this.id,
              'name': this.service_name,
              'code': this.service.product_code,
              'cost': parseFloat(this.service.cost)
            }
            localStorage.setItem('service', JSON.stringify(service));
            this.cost = this.service.cost ? parseInt(this.service.cost) : 0
            this.image = this.service.image
            this.buy_success = this.service.buy_success
            this.description = this.service.description ? this.service.description.substring(0, 250) + '...' : ''
            this.order.product_code = res.data.product_code
            this.order.payment_method = 4
            if (res.data.attribute && res.data.attribute.length > 0) {
              res.data.attribute.forEach(item => {
                let value = ''
                if (item.product_attribute_code === 'nam_sinh_cua_ban') {
                  value = this.convertDate()
                }

                this.inputs.push({
                  display: item.product_attribute_display,
                  code: item.product_attribute_code,
                  value: value,
                  type: item.product_attribute_input_type,
                  sub_items: item.product_attribute_input_value
                })
              })
            }

            if (this.cost > 0) {
              this.is_laso = (this.service.laso && this.service.laso.length > 0) ? 1 : 0;
            }
            this.attributes = res.data.attribute

          } else if (res.status === 401 || res.status === 403) {
            this.$router.push({path: `/login`})
          } else {
            errorToaster('Cố vấn phong thủy', res.message)
          }
        }).catch(err => {
          errorToaster('Cố vấn phong thủy', 'Xảy ra lỗi kết nối')
        })
      },

      getFlashSale () {
        rf.getRequest('ServiceRequest').getFlashSale().then((res) => {
          if (res.status === 200) {
            const [flash] = res.data
            this.flash_sale = flash.description
            localStorage.setItem('flash_sale', JSON.stringify(flash));
          } else if (res.status === 401 || res.status === 403) {
            this.$router.push({path: `/login`})
          } else {
            errorToaster('Cố vấn phong thủy', res.message)
          }
        }).catch(e => {
          console.error(e)
        })
      },

      getResult () {
        this.order.attrs = []
        if (this.inputs && this.inputs.length > 0) {
          for (let i = 0; i < this.inputs.length; i++) {
            let item = this.inputs[i]
            let value = item.value
            if (item.type === 'date') {
              value = this.$date(new Date(item.value), 'dd/MM/yyyy')
            }
            if (item.type === 'month') {
              value = this.$date(new Date(item.value), 'MM/yyyy')
            }
            this.order.attrs.push({
              value: value,
              code: item.code
            })
          }
        }
        localStorage.setItem('orders', JSON.stringify(this.order));
        if (this.cost > 0)
          this.$router.push({path: `/preview`});
        else
          this.orderService();
      },

      orderService () {
        let that = this
        rf.getRequest('ServiceRequest').orderService(this.order).then((res) => {
          if (res.status === 200) {
            if (that.cost > 0) {
              const req = {
                order_id: res.data.order_id,
                order_code: res.data.order_code,
                customer_number: this.phone,
                description: `Thanh toan don hang ${res.data.order_code}`,
                amount: parseInt(res.data.price),
                payment_type: OrderType.ORDER_DV
              }
              this.requestViettel(req)
            } else {
              localStorage.setItem('result_service', JSON.stringify(res.data))
              this.$router.push({path: '/services/result/' + this.id})
            }
          } else if (res.status === 401 || res.status === 403) {
            this.$router.push('/login')
          } else {
            errorToaster('Cố vấn phong thủy', res.message)
          }
        }).catch(err => {
          errorToaster('Cố vấn phong thủy', 'Xảy ra lỗi kết nối')
        })
      },

      requestViettel (req) {
        rf.getRequest('OrderRequest')
          .viettelPayCourse(req)
          .then(res => {
            if (res.status === 200) {
              window.location.href = res.data
            } else {
              errorToaster('Cố vấn Phong Thủy', res.message)
            }
          })
          .catch(err => {
            errorToaster('Cố vấn Phong Thủy', 'Xảy ra lỗi kết nối')
          })
      },

      listLaso () {
        this.$router.push('/laso')
      },

      onSlideStart () {
        this.sliding = false
        this.description = this.service.description
      },

      onSlideEnd () {
        this.sliding = true
        this.description = this.service.description ? this.service.description.substring(0, 250) + '...' : ''
      },
    }

  }
</script>

<style scoped>
  .fr_form {
    background-color: #efefef;
  }

  .time {
    border: 0 !important;
  }

  input.display-time {
    border: 0 !important;
  }

  .display-time {
    border: 0 !important;
  }

  .img_center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-height: 172px;
  }

  .content_service {
    display: flex;
    justify-content: center;
  }

  .show_read_mode, .hide_read_mode {
    position: absolute;
    bottom: 0em;
    z-index: 10;
    text-align: center;
  }

  .flash_sale {
    color: red;
    font-size: small;
    font-style: italic;
    font-weight: bold;
  }

  .show_read_mode:target {
    display: none;
  }

  .show_read_mode:target ~ .hide_read_mode {
    display: block;
  }

  .show_read_mode:target ~ .panel_read_more {
    max-height: 2000px;
    font-size: 14px;
  }

  .panel_read_more {
    position: relative;
    margin: 2em auto;
    width: 100%;
    font-size: 15px;
    overflow: hidden;
    transition: max-height .5s ease;
    white-space: pre-line;
  }

  .btn_read_mode {
    color: #000;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    padding: 0.5em;
    text-decoration: none;
    width: 100%;
  }

  .show_read_mode, .hide_read_mode {
    position: absolute;
    bottom: -3em;
    right: 0em;
    z-index: 10;
    text-align: center;
  }

  .line-rating div[data-v-cce46000] {
    font-size: 11px;
  }

  .hide_read_mode {
    display: none;
  }

  .show_read_mode:target {
    display: none;
  }

  .show_read_mode:target ~ .hide_read_mode {
    display: block;
  }

  .show_read_mode:target ~ .panel_read_more {
    max-height: 2000px;
    font-size: 14px;
  }

  .show:target ~ .fade {
    margin-top: 0;
  }

  .clock-picker__input {
    width: 100%;
    border: 0 solid gainsboro !important;
  }

  .customize_clock-picker {
    width: 100%;
    border: 1px solid gainsboro !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/service/ServiceDetail.vue